import React from 'react'
import { IMaskInput } from 'react-imask';

const TextMaskLicenseNo = React.forwardRef(
    function TextMaskLicenseNo(props, ref) {
        const { onChange, ...other } = props;
        return (
            <div>
                <IMaskInput
                    {...other}
                    mask="0000000000"
                    // mask="000-000000-0"
                    definitions={{ "#": /[1-9]/ }}
                    inputRef={ref}
                    onAccept={(value) => onChange({ target: { name: props.name, value } })}
                    overwrite
                />
                {/* {props.testA} */}
            </div>
        );
    }
);
export default TextMaskLicenseNo;
